import type { ComponentPropsWithoutRef } from 'react'

type Props = ComponentPropsWithoutRef<'svg'>

export function ChatIcon(props: Props) {
  return (
    <svg width="24" height="24" viewBox="0 0 60 60" fill="#1B1C1B" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M30 7.5C43.36 7.5 55 16.6075 55 28.75C55 40.8925 43.36 50 30 50C28.6875 50 27.395 49.915 26.135 49.75L18.885 54.58C18.4736 54.854 17.9903 54.9999 17.496 54.9993C17.0017 54.9986 16.5187 54.8515 16.108 54.5765C15.6974 54.3014 15.3774 53.9108 15.1887 53.454C14.9999 52.9972 14.9508 52.4947 15.0475 52.01L16.16 46.4575C9.57 42.725 5 36.2925 5 28.75C5 16.6075 16.64 7.5 30 7.5ZM30 12.5C18.5075 12.5 10 20.1825 10 28.75C10 34.5875 13.86 39.9375 20.0425 42.8375C20.5485 43.0749 20.9604 43.475 21.2124 43.9739C21.4644 44.4729 21.5419 45.0419 21.4325 45.59L21.135 47.0725L24.1625 45.0525C24.6917 44.6999 25.3354 44.5622 25.9625 44.6675C27.2625 44.885 28.6125 45 30 45C41.4925 45 50 37.3175 50 28.75C50 20.1825 41.4925 12.5 30 12.5Z" />
    </svg>
  )
}
